import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { Mail, User } from 'lucide-react';

interface EmailMismatchDialogProps {
  open: boolean;
  invitedEmail: string;
  currentEmail: string;
  onConfirmSwitch: () => void;
  onCancel: () => void;
}

export function EmailMismatchDialog({
  open,
  invitedEmail,
  currentEmail,
  onConfirmSwitch,
  onCancel,
}: EmailMismatchDialogProps) {
  return (
    <AlertDialog open={open}>
      <AlertDialogContent className="max-w-md">
        <AlertDialogHeader>
          <AlertDialogTitle className="text-xl">Email Mismatch</AlertDialogTitle>
          <AlertDialogDescription asChild>
            <div className="space-y-4 pt-2">
              <p className="text-sm text-foreground">
                This invitation was sent to a different email address than the one you're currently logged in with.
              </p>
              
              <div className="space-y-3 py-2">
                <div className="flex items-start gap-3 p-3 rounded-lg bg-primary/10 border border-primary/20">
                  <Mail className="h-5 w-5 text-primary mt-0.5 flex-shrink-0" />
                  <div className="flex-1 min-w-0">
                    <p className="text-xs font-medium text-muted-foreground mb-1">
                      Invitation sent to:
                    </p>
                    <p className="text-sm font-semibold text-primary break-all">
                      {invitedEmail}
                    </p>
                  </div>
                </div>
                
                <div className="flex items-start gap-3 p-3 rounded-lg bg-muted/50 border border-border">
                  <User className="h-5 w-5 text-muted-foreground mt-0.5 flex-shrink-0" />
                  <div className="flex-1 min-w-0">
                    <p className="text-xs font-medium text-muted-foreground mb-1">
                      Currently logged in as:
                    </p>
                    <p className="text-sm font-medium text-foreground break-all">
                      {currentEmail}
                    </p>
                  </div>
                </div>
              </div>
              
              <p className="text-sm text-muted-foreground pt-2">
                To accept this invitation, you need to log in with the invited email address. 
                Click "Switch Account" to automatically log out and continue.
              </p>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onCancel}>
            Cancel
          </AlertDialogCancel>
          <AlertDialogAction onClick={onConfirmSwitch} className="bg-primary">
            Switch Account
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
